import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { ConfiguracionService } from 'src/app/services/configuracion.service';
import { Pregunta } from 'src/app/types/type';

@Component({
  selector: 'app-form-new-question',
  templateUrl: './form-new-question.component.html',
  styleUrls: ['./form-new-question.component.css']
})
export class FormNewQuestionComponent {
  @Input() preguntaEdit?: Pregunta;
  @Input() totalPonderaciones: number;
  @Output() saveQuestionChild = new EventEmitter();
  form: FormGroup;
  btnDisable = false;

  constructor(private formBuilder: FormBuilder, private configService: ConfiguracionService) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      pregunta: ['', [Validators.required]],
      checkEvidencia: [true],
      checkComentario: [false],
      ponderacion: [0, [Validators.required, Validators.min(0), Validators.max(100), Validators.maxLength(3)]],
      orden: [0]
    });
  }

  ngOnChanges() {
    if (this.validPreguntaEdit()) {
      this.form.setValue({
        pregunta: this.preguntaEdit.Descripcion,
        checkEvidencia: this.preguntaEdit.FlagEvidencia,
        checkComentario: this.preguntaEdit.FlagComentario,
        ponderacion: this.preguntaEdit.Ponderacion,
        orden: this.preguntaEdit.Orden
      })
    }
  }

  formNewPregunta() {
    if (this.form.valid) {
      this.btnDisable = true;
      const {
        pregunta,
        checkEvidencia,
        checkComentario,
        ponderacion,
        orden
      } = this.form.value;

      if (this.totalPonderaciones + ponderacion > 100) {
        this.btnDisable = false;
        Utilerias.alertClient('', 'Las ponderaciones no pueden sumar mas de 100', 0);
        return
      }

      if (localStorage.IdPreguntaEdit) {
        this.configService.updatePregunta({
          IdPregunta: parseInt(localStorage.IdPreguntaEdit),
          Descripcion: pregunta,
          Orden: orden,
          FlagEvidencia: checkEvidencia,
          FlagComentario: checkComentario,
          Ponderacion: ponderacion,
        })
          .subscribe(response => {
            if (response.Result.Exito) {
              const pregunta = response.Result.Data as Pregunta;
              this.saveQuestionChild.emit(pregunta);
              this.reset();
              this.preguntaEdit = undefined;
            } else {
              Utilerias.alertClient('', response.Result.Error, 1);
            }
          });
      } else {
        this.configService.postSetPregunta({
          IdRubro: parseInt(localStorage.IdRubroNewPregunta),
          Descripcion: pregunta,
          FlagEvidencia: checkEvidencia,
          FlagComentario: checkComentario,
          Ponderacion: ponderacion,
        })
          .subscribe(response => {
            if (response.Result.Exito) {
              const pregunta = response.Result.Data as Pregunta;
              this.saveQuestionChild.emit(pregunta);
              this.reset();
            } else {
              Utilerias.alertClient('', response.Result.Error, 1);
            }
          });
      }
    }
  }

  validPreguntaEdit() {
    if (this.preguntaEdit !== undefined) return true;
    return false;
  }

  reset() {
    this.btnDisable = false;
    this.form.setValue({
      pregunta: '',
      checkEvidencia: true,
      checkComentario: false,
      ponderacion: 0,
      orden: 0
    })
  }
}
